export class DirectDebitFile {
    id: string;
    directDebitFileDate: string;  minCollectionDate: any;

    amount: string;
    companyName: string;
    startDateTime: string;
    endDateTime: string;
}

export class DirectDebitFileXML {
    id:string;
    companyName: string;
    xmlFile:string;
    errors:string[];
    minCollectionDate:string;    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/models/direct-debit-file.model.ts